import {
  EXPERIENCE_TYPE,
  SEGMENT_WRITE_KEY_STAGING,
  SEGMENT_WRITE_KEY_PRODUCTION,
} from './constants';

/**
 * Create the page name for analytics.
 * @param pageType
 * @param pageDetail
 * @returns {string}
 */
export function getEventPageName(pageType, pageDetail) {
  if (pageType && pageDetail) {
    return `${EXPERIENCE_TYPE}>${pageType}>${pageDetail}`;
  }
  if (pageType) {
    return `${EXPERIENCE_TYPE}>${pageType}`;
  }
  return `${EXPERIENCE_TYPE}`;
}

/**
 * Get the write key, given the process.env.NODE_ENV.
 * @returns {string}
 */
export function getWriteKey() {
  return process.env.NODE_ENV.startsWith('prod')
    ? SEGMENT_WRITE_KEY_PRODUCTION
    : SEGMENT_WRITE_KEY_STAGING;
}

export function getAnalyticsClient() {
  // TODO: clean up this server check
  if (typeof window !== 'undefined') {
    return window.webShellClient.analytics;
  }
}
